import {useCallback} from 'react';
import {useNavigate, useParams} from 'react-router';

export function useNavigateToOtherLangOfPage() {
  const {lang: langSegment} = useParams();
  const navigate = useNavigate();

  return useCallback(
    (lang: string) => {
      const rest = langSegment
        ? location.pathname.slice(langSegment.length + 1)
        : location.pathname;

      navigate({
        pathname: lang === 'en' ? rest || '/' : `/${lang}${rest}`,
        search: location.search,
        hash: location.hash,
      });
    },
    [langSegment, navigate]
  );
}
